import * as React from "react";
const SvgFiRrToriiGate = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-torii-gate_svg__a)">
      <path
        fill="#062147"
        d="M23.174.344c-.741-.515-1.726-.451-2.32.095l-.453.34a5.28 5.28 0 0 1-3.373 1.22H6.925A5.33 5.33 0 0 1 3.509.746L3.173.5A1.91 1.91 0 0 0 .779.345a1.916 1.916 0 0 0-.522 2.618l.82 1.477C1.703 5.86 2.803 7.005 4 7.794V11H3a1 1 0 0 0 0 2h1v10a1 1 0 0 0 2 0V13h12v10a1 1 0 0 0 2 0V13h1a1 1 0 0 0 0-2h-1V7.764c1.175-.788 2.305-1.923 2.922-3.324l.771-1.474a1.92 1.92 0 0 0-.52-2.622M6 8.708A7.4 7.4 0 0 0 8.046 9H11v2H6zM18 11h-5V9h2.906c.725 0 1.426-.107 2.094-.303zm2.948-7.426C20.04 5.687 18.567 7 15.906 7h-7.86A5.63 5.63 0 0 1 2.88 3.574c-.021-.05-.61-1.26-.61-1.26A7.3 7.3 0 0 0 6.926 4h10.103a7.24 7.24 0 0 0 4.61-1.651s-.67 1.175-.69 1.225"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-torii-gate_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrToriiGate;
